import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@chapche/ui';
import { Pagination } from '../../Pagination';
import DeletePropertyPopup from './DeletePropertyPopup';
import { propertiesStorage } from '../../../services/propertiesStorage';
import CreateNewPropertyButton from './CreateNewPropertyButton';
import DownloadPropertiesCsvButton from './DownloadPropertiesCsvButton';
import SearchItemBlock from '../../../shared/SearchItemBlock';
import PropertiesList from './PropertiesList';
import PropertyTable from './PropertyTable';
import CreateNewPropertyPopup from './CreateNewPropertyPopup';
import useWindowDimensions from '../../../hooks/useWindowDimension';
import RestoreItemPopup from '../../../shared/RestoreItemPopup';
import { propertyRestoreService } from '../../../services/propertyRestoreService';
import { useListViewMode } from '../../../shared/listView/useListViewMode';
import ListViewSwitcher from '../../../shared/listView/ListViewSwitcher';
import {
    PAGE_TAB_NAME_COMPOSITION_TREE,
    PRODUCT_TAB,
    PROPERTY_TAB_NAME,
} from '../../../constant';

const PropertyListTab = () => {
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const { width } = useWindowDimensions();
    const { mode, setMode, isTableForcedOff } = useListViewMode('property');
    const [, setRevision] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const notifyPropertiesList = () => {
        propertiesStorage.loadItems(() => setRevision((value) => value + 1), width);
    };

    useEffect(() => {
        const onChange = () => {
            setIsLoading(false);
            setRevision((value) => value + 1);
        };
        propertiesStorage.loadItems(onChange, width);
        propertiesStorage.registerFiltersChangingObserver(onChange);
        return () => {
            propertiesStorage.unRegisterFiltersChangingObserver(onChange);
            // Reset list UI state without refetch — changeDeletedItemsView() would
            // call loadItems() on the way out and flood the connection pool.
            propertiesStorage.page = 1;
            propertiesStorage.showDeletedProperties = false;
        };
        // Mount-only list bootstrap (width captured for initial load).
        // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional
    }, []);

    const items = mode === 'table'
        ? propertiesStorage.getItems(true)
        : propertiesStorage.getItems();

    return (
        <>
            <SearchItemBlock
                itemsStorageService={propertiesStorage}
                placeholder={i18n.t('app.page.product.propertySearch')}
                actions={(
                    <>
                        <Button
                            variant="outline"
                            onClick={() => navigate(`/${PRODUCT_TAB}/${PROPERTY_TAB_NAME}/${PAGE_TAB_NAME_COMPOSITION_TREE}`)}
                        >
                            {i18n.t('app.page.property.composition.openTree')}
                        </Button>
                        <CreateNewPropertyButton />
                        <DownloadPropertiesCsvButton />
                        <ListViewSwitcher
                            mode={mode}
                            onChange={setMode}
                            disabled={isTableForcedOff}
                        />
                    </>
                )}
            />
            {mode === 'table' ? (
                <PropertyTable items={items} isLoading={isLoading} />
            ) : (
                <PropertiesList items={items} />
            )}
            {mode === 'tile' ? <Pagination itemsStorageService={propertiesStorage} /> : null}
            <DeletePropertyPopup notifyPropertiesList={notifyPropertiesList} />
            <CreateNewPropertyPopup />
            <RestoreItemPopup
                itemRestoreService={propertyRestoreService}
                notifyItemsList={notifyPropertiesList}
            />
        </>
    );
};

export default PropertyListTab;
